export default "__VITE_ASSET__CvTW3rsI__"